import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
    apiKey: "AIzaSyBB33p0LAOGYsoCi6dTfOLLAg_tATX0lio",
    authDomain: "dictionary-60c25.firebaseapp.com",
    projectId: "dictionary-60c25",
    storageBucket: "dictionary-60c25.firebasestorage.app",
    messagingSenderId: "99073753858",
    appId: "1:99073753858:web:e7851f801f4819afba781b",
    measurementId: "G-31N2XV2BNW"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

export { db, auth, storage };
